import { Injectable } from '@angular/core';
import { VERSION, VersionInfo, getVersionString, getFullVersionString } from '../config/version';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  constructor() {}

  getVersion(): VersionInfo {
    return VERSION;
  }

  getVersionString(): string {
    return getVersionString();
  }

  getFullVersionString(): string {
    return getFullVersionString();
  }

  getBuildDate(): Date {
    return new Date(VERSION.buildDate);
  }

  getCommitHash(): string | undefined {
    return VERSION.commitHash;
  }
}
